import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/news';

const ranked = [...articles].sort((a, b) => b.heat - a.heat);

export default function HeatRanking() {
  const featured = ranked[0];
  const list = ranked.slice(1, 7);

  return (
    <section id="heat" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 border-b border-background-300 pb-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.25em] text-accent-600">WEEKLY HEAT</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">本周热度榜</h2>
            <p className="mt-2 text-sm text-foreground-600">按当前讨论热度排序，方便你优先补最值得看的话题。</p>
          </div>
          <Link
            to="/topics"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部话题
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Link
              to={`/article/${featured.id}`}
              className="group block overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="relative h-72 w-full overflow-hidden md:h-96">
                <img
                  src={featured.image}
                  alt={featured.title}
                  title={`${featured.title} - 看料大瓜`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-5 top-5 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1.5 text-xs font-medium text-background-50">
                  <i className="ri-fire-fill" aria-hidden="true"></i>
                  热度榜首
                </span>
              </div>
              <div className="p-6">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-900">{featured.categoryName}</span>
                  <span>{featured.date}</span>
                  <span>· {featured.readTime}</span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
              </div>
            </Link>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-6 lg:col-span-5">
            <h3 className="font-heading text-base font-bold text-foreground-950">热度紧随其后</h3>
            <div className="mt-3">
              {list.map((item, idx) => (
                <ArticleCard key={item.id} article={item} variant="compact" index={idx + 1} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}